export type AgendaTab = 'consultas' | 'configurar';

/** Query `tab=configurar` ou `tab=config` abre a aba de configuração; qualquer outro valor cai em Consultas. */
export function resolveAgendaTab(raw: string | null | undefined): AgendaTab {
  if (raw === 'configurar' || raw === 'config') {
    return 'configurar';
  }
  return 'consultas';
}
